import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const HeartOutlineIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M23.514 21.503c1.622-1.386 3.025-2.735 3.612-3.683.892-1.44 1.523-3.017 1.418-5.097C28.358 9.041 25.52 6 22.046 6c-3.42 0-6.101 4.045-6.101 4.045h-.001S13.26 6 9.843 6C6.368 6 3.53 9.041 3.345 12.723c-.105 2.08.525 3.657 1.417 5.097 1.791 2.89 11.174 9.52 11.182 9.513.003.003 1.492-1.046 3.397-2.493Z"
    />
  </IconV2>
);

export default HeartOutlineIcon;
